var map = {
	"./bg2.png": "./app/javascript/images/bg2.png",
	"./favicon.png": "./app/javascript/images/favicon.png",
	"./loading.gif": "./app/javascript/images/loading.gif",
	"./logo.png": "./app/javascript/images/logo.png",
	"./logo_mobile_header.png": "./app/javascript/images/logo_mobile_header.png",
	"./logo_white_216.png": "./app/javascript/images/logo_white_216.png",
	"./pagina_login.png": "./app/javascript/images/pagina_login.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";